@if (hasNewsletter()) {
  <section
    class="subscribe-newsletter"
    id="newsletterContainer"
    [hidden]="
      (newsletterFooter() && subscribedToNewsletter() && showNewsletterFooterBeforeSubscrited) ||
      (newsletterFooter() && hideAfterSubmit)
    "
    [ngClass]="{
      'subscribe-newsletter__footer': newsletterFooter(),
      'subscribe-newsletter__popup': !newsletterFooter(),
    }"
  >
    <div class="container">
      @if (newsletterData) {
        <div class="subscribe-newsletter__content" [ngClass]="{ row: !newsletterFooter() }">
          @if (!newsletterFooter()) {
            <div class="subscribe-newsletter__image col-12 col-lg-6 col-md-6 col-sm-12">
              <picture>
                <source media="(max-width: 767.9px)" [srcset]="newsletterData.mobileImage + '?format=webp&width=600 600w'" />
                <source media="(min-width: 768px)" [srcset]="newsletterData.desktopImage + '?format=webp&width=456 456w'" />
                <img
                  alt="news letter image"
                  ngSrcset="456w, 600w"
                  width="456"
                  height="600"
                  [src]="newsletterData.desktopImage + '?format=webp&width=456 456w'"
                  (error)="newsletterData.desktopImage = missingProductImageUrl"
                />
              </picture>
            </div>
          }
          <div
            class="subscribe-newsletter__popup-content"
            [ngClass]="{ 'col-12 col-lg-6 col-md-6 col-sm-12': !newsletterFooter() }"
          >
            <div class="subscribe-newsletter__popup-content-text" [ngClass]="{ row: newsletterFooter() }">
              @if (C360SelectionsEnabled && !newsletterFooter()) {
                <div class="subscribe-newsletter__form-c360-selection-section">
                  <div class="subscribe-newsletter__form-c360-selection-section-title">{{ C360SelectionsTitle }}</div>
                  <ul class="subscribe-newsletter__form-c360-selection-section-container">
                    @for (C360Selection of C360Selections; track C360Selection) {
                      <li
                        class="subscribe-newsletter__form-c360-selection-section-container-selection"
                        [ngClass]="{ 'c360-selection-selected': C360Selection.value === currentc360Selection?.value }"
                      >
                        <a
                          role="button"
                          tabindex="0"
                          (click)="selectC360Element(C360Selection)"
                          (keypress)="selectC360Element(C360Selection)"
                        >
                          <div class="subscribe-newsletter__form-c360-selection-section-container-selection-image">
                            <img [src]="C360Selection.image" [alt]="C360Selection.text" />
                          </div>
                          <div class="subscribe-newsletter__form-c360-selection-section-container-selection-text">
                            <span>{{ C360Selection.text }}</span>
                          </div>
                        </a>
                        <div class="c360-selection-selected-placeholder"></div>
                      </li>
                    }
                  </ul>
                </div>
              }
              @if (!newsletterFooter()) {
                <h3 class="subscribe-newsletter__form-title" i18n="@@NEWSLETTER_TITLE">Subscribe!</h3>
              }
              <div class="subscribe-newsletter__offer" [ngClass]="{ 'col-12 col-sm-12 col-md-6 col-lg-5': newsletterFooter() }">
                <h2 class="subscribe-newsletter__offer-title">
                  <span [innerHtml]="newsletterData.newsletterTitle | localeData">
                    {{ newsletterData.newsletterTitle | localeData }}
                  </span>
                </h2>
                <h2 class="subscribe-newsletter__offer-subtitle" [innerHtml]="newsletterData.newsletterSubtitle | localeData">
                  {{ newsletterData.newsletterSubtitle | localeData }}
                </h2>
              </div>
              <div class="subscribe-newsletter__form" [ngClass]="{ 'col-12 col-sm-12 col-md-6 col-lg-7': newsletterFooter() }">
                @if (newsletterFooter()) {
                  <h3 class="subscribe-newsletter__form-title section-down" i18n="@@NEWSLETTER_TITLE">Subscribe!</h3>
                }
                <form [formGroup]="newsletterForm" (ngSubmit)="checkInputDefault(); subscribeNewsletter()">
                  @if (!subscribed) {
                    <div
                      class="subscribe-newsletter__form-input required-field"
                      [ngClass]="{ 'input-effect': !newsletterFooter() }"
                    >
                      <input
                        type="text"
                        formControlName="name"
                        class="effect form-control"
                        name="name"
                        required
                        [ngClass]="{ 'is-valid': formControls.name.value !== '' }"
                        [placeholder]="localization === 'fr-FR' ? 'Votre Nom *' : 'Nombre *'"
                      />
                      <label for="name" i18n="@@YOUR_NAME">Your name</label>
                    </div>
                  }
                  @if (!subscribed) {
                    <div
                      class="subscribe-newsletter__form-input required-field"
                      [ngClass]="{ 'input-effect': !newsletterFooter() }"
                    >
                      <input
                        type="email"
                        formControlName="email"
                        class="effect form-control"
                        name="email"
                        required
                        [ngClass]="{
                          'is-invalid': formControls.email.errors && formControls.email.value !== '',
                          'is-valid': !formControls.email.errors,
                        }"
                        [placeholder]="localization === 'fr-FR' ? 'Votre Email *' : 'Email *'"
                      />
                      <label for="email" i18n="@@YOUR_EMAIL">Your email</label>
                      <button
                        type="submit"
                        class="btn"
                        [ngClass]="{ 'btn-icon': !showSubmitLabel(), 'btn-primary': showSubmitLabel() }"
                        [disabled]="formControls.name.errors || formControls.email.errors"
                      >
                        <div class="sr-only">{{ newsletterData.buttonTitle | localeData }}</div>
                        @if (showSubmitLabel()) {
                          <span>{{ newsletterData.buttonTitle | localeData }}</span>
                        }
                        @if (!showSubmitLabel()) {
                          <i class="fal fa-arrow-right"></i>
                        }
                      </button>
                    </div>
                  }
                  <div
                    class="valid-feedback"
                    [ngClass]="{
                      valid: subscribed,
                    }"
                    i18n="@@THANKYOU_NEWSLETTER"
                  >
                    Thank you for signing up!
                  </div>
                  <div class="subscribe-newsletter__form-submit">
                    @if (!subscribed) {
                      <button
                        type="submit"
                        class="btn"
                        [ngClass]="{ 'btn-icon': !showSubmitLabel(), 'btn-primary': showSubmitLabel() }"
                        [disabled]="formControls.name.errors || formControls.email.errors"
                      >
                        <div class="sr-only">{{ newsletterData.buttonTitle | localeData }}</div>
                        @if (showSubmitLabel()) {
                          <span>{{ newsletterData.buttonTitle | localeData }}</span>
                        }
                        @if (!showSubmitLabel()) {
                          <i class="fal fa-arrow-right"></i>
                        }
                      </button>
                    }
                  </div>
                  <div class="form-check-label-before">
                    @if (localization !== 'fr-FR') {
                      <h3 i18n="@@NEWSLETTER_CHECKOUT">Contenuti pensati per te!</h3>
                    }
                    <p i18n="@@NEWSLETTER_CHECKOUT_TXT_1">
                      Vorrei ricevere offerte, contenuti e comunicazioni personalizzati.<a href="{{ generateLocalizedURL(1) }}"
                        >url</a
                      >
                    </p>
                  </div>
                  <div class="subscribe-newsletter__form-check" [ngClass]="{ 'form-check-label-before': subscribed }">
                    @if (localization === 'es-ES') {
                      <div class="hidden-fr">
                        @if (!subscribed) {
                          <input
                            type="checkbox"
                            class="form-check-input"
                            formControlName="subscribe_promotion"
                            name="promotionCheckBox"
                            id="promotionCheckBoxId"
                            [ngClass]="{
                              'is-invalid': isSubmitted && !formControls.subscribe_promotion.enabled,
                            }"
                            (change)="onPrivacyPolicyCheckChange()"
                          />
                        }
                      </div>
                    }
                    <label
                      class="form-check-label"
                      for="promotionCheckBoxId"
                      [ngClass]="{ 'form-check-label-before': localization === 'fr-FR' }"
                    >
                      @if (localization === 'es-ES') {
                        <div class="hidden-fr">
                          @if (!subscribed) {
                            <h3 i18n="@@PROMOTION_CHECKOUT">Contenuti pensati per te!</h3>
                          }
                          @if (!subscribed) {
                            <p i18n="@@PROMOTION_CHECKOUT_TXT">
                              Vorrei ricevere offerte, contenuti e comunicazioni personalizzati.<a
                                href="{{ generateLocalizedURL(1) }}"
                                >url</a
                              >
                            </p>
                          }
                        </div>
                      }
                      <div class="subscribe-newsletter__form-check">
                        <div class="hidden-text">
                          <p class="cusheight" i18n="@@NEWSLETTER_CHECKOUT_TXT_2A">
                            I dati da te forniti saranno trattati da...<a target="_blank" href="{{ generateLocalizedURL(4) }}"
                              >url</a
                            >
                          </p>
                          <p class="cusheight" i18n="@@NEWSLETTER_CHECKOUT_TXT_2B">
                            I dati da te forniti saranno trattati da...<a target="_blank" href="{{ generateLocalizedURL(4) }}"
                              >url</a
                            >
                            <a href="{{ generateLocalizedURL(2) }}">url</a>
                          </p>
                          <p i18n="@@NEWSLETTER_CHECKOUT_TXT_3">
                            informativa estesa<a href="{{ generateLocalizedURL(3) }}">url</a>
                          </p>
                          @if (hiddenLabelsControl === 1) {
                            <div class="more-details">
                              <h3 i18n="@@MORE_DETAILS_TITLE">
                                Relevant information about advertising and personalized online ads
                              </h3>
                              <p i18n="@@OUR_OBJETIVE">Our objetive</p>
                              @if (localization === 'es-ES') {
                                <p i18n="@@CONSENT_TO_ANALYSIS">Consent to analysis</p>
                              }
                              <ul>
                                <p>
                                  <li i18n="@@CONSENT_TO_ANALYSIS_POINT_A">
                                    We will collect your preferences and behaviors and combine and analyze them.
                                  </li>
                                </p>
                                <p i18n="@@CONSENT_TO_ANALYSIS_POINT_A_A">
                                  We will enrich that data with attributes and preferences obtained from commercially available
                                  sources, or from third parties. Similarly, if you have accepted our targeted advertising cookies
                                  or similar technologies on P&G or, in some cases, third-party websites or applications, we may
                                  supplement the data obtained through targeted advertising cookies with other information that
                                  you have consented to disclose when created an account or have interacted with our services.
                                </p>
                                @if (localization === 'es-ES') {
                                  <p i18n="@@CONSENT_TO_ANALYSIS_POINT_A_B">
                                    We will process that data, including by automated means, to personalize our content and offers
                                    via email, online (for example on third party platforms, including social media platforms) and
                                    offline (for example via paper mail) if you have consented to receive commercial
                                    communications from we.
                                  </p>
                                }
                                <p>
                                  <li i18n="@@CONSENT_TO_ANALYSIS_POINT_B">
                                    Use your personal data to target you in online media.
                                  </li>
                                </p>
                                @if (localization === 'es-ES') {
                                  <p i18n="@@CONSENT_TO_ANALYSIS_POINT_B_A">
                                    This will help us to send you more relevant online advertisements (offers, information about
                                    products and innovations), as well as to serve you with fewer advertisements, since we will
                                    know when we have already reached you with a certain advertisement and we will be able to
                                    exclude you from further communications on the same topic. Most of our consumers appreciate
                                    that we don't want to show them ads for products they're not interested in or have seen
                                    numerous times before, but if you don't want to, that's okay - you can always change your
                                    preferences.
                                  </p>
                                }
                                <p><li i18n="@@ADVERTISING_C">Look-alike advertising</li></p>
                                @if (localization === 'fr-FR') {
                                  <p i18n="@@ADVERTISING_C_C_A">
                                    This will help us to send you more relevant online advertisements (offers, product information
                                    and innovations) and to serve you fewer advertisements, since we will know when we have
                                    already shown you a certain advertisement and can exclude you from any other communication on
                                    the same subject. Most of our consumers appreciate that we don't show them ads for products
                                    they're not interested in or that we've already shown them multiple times, but if that's not
                                    the case for you, no problem: you can always change your preferences.
                                  </p>
                                }
                                <p i18n="@@ADVERTISING_C_A">
                                  You can always change your mind and withdraw your consent by unchecking the “Content designed
                                  for you!” in your Profile (when available), or opting out of the use of your data for
                                  personalized advertising (including the creation of tailored audiences and look-alike
                                  audiences), here. Read our privacy policy.<a href="{{ generateLocalizedURL(1) }}">url</a>
                                </p>
                                <p i18n="@@ADVERTISING_C_A_B">
                                  Read our privacy policy.<a href="{{ generateLocalizedURL(2) }}">url</a>
                                </p>
                              </ul>
                            </div>
                          }
                          @if (hiddenLabelsControl === 2) {
                            <div class="read-here">
                              <h3 i18n="@@READ_HERE_TITLE">We value your privacy</h3>
                              <ul>
                                <p>
                                  <li i18n="@@READ_HERE_POINT_1">
                                    Our Privacy Policy governs our collection and use of your data.<a
                                      href="{{ generateLocalizedURL(2) }}"
                                      >url</a
                                    >
                                  </li>
                                </p>
                                <p>
                                  <li i18n="@@READ_HERE_POINT_2">
                                    That is why we are collecting your data, our legal bases for processing, and the period for
                                    which your personal data will be stored.<a href="{{ generateLocalizedURL(2) }}">url</a>
                                  </li>
                                </p>
                                <p>
                                  <li i18n="@@READ_HERE_POINT_3_A">
                                    Our emails contain pixels that help P&G understand whether you interact with them and what
                                    content has been interesting to you. Learn more here.<a href="{{ generateLocalizedURL(2) }}"
                                      >url</a
                                    >
                                  </li>
                                </p>
                                <p i18n="@@READ_HERE_POINT_3_B">
                                  You can unsubscribe from our email communication programs at any time.<a
                                    href="{{ generateLocalizedURL(1) }}"
                                    >url</a
                                  >
                                </p>
                                <p>
                                  <li i18n="@@READ_HERE_POINT_4">
                                    Your data will be processed in a country outside of which it was collected, including the
                                    United States. Learn more here.<a href="{{ generateLocalizedURL(2) }}">url</a>
                                  </li>
                                </p>
                                <p>
                                  <li i18n="@@READ_HERE_POINT_5">
                                    You can exercise your rights over your data (you can access, correct, delete, transfer to
                                    another provider, object to or restrict our processing of the personal data we have about you,
                                    or revoke your consent) or change your preferences and subscriptions by clicking here.<a
                                      href="{{ generateLocalizedURL(1) }}"
                                      >url</a
                                    >
                                  </li>
                                </p>
                              </ul>
                            </div>
                          }
                        </div>
                      </div>
                    </label>
                  </div>
                </form>
                @if (localization === 'es-ES') {
                  <p class="label-promo" i18n="@@PROMO_NEWSLETTER">*Promo newsletter</p>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </section>
}
